module.exports = __webpack_public_path__ + "static/media/Quebrith.e3bf3d1b.svg";